<script lang="ts">
import { ref, defineComponent } from 'vue';

export default defineComponent({
    props: {
        hasHeader: {
            type: Boolean,
            required: true
        }
    },
    setup(props, { emit }) {
        const showHeader = ref(props.hasHeader);
        const closeModal = () => {
            emit('closeModal');
            return true;
        };

        return {
            closeModal,
            showHeader
        };
    }
});
</script>

<template>
    <transition name="modal-fade">
        <div class="m-searchFilter-backdrop"
             @click.self="closeModal">
            <div class="m-searchFilter-modal"
                 role="dialog"
            >
                <header v-if="showHeader" class="m-searchFilter-modal__header">
                    <slot name="header">
                        <button type="button" class="btn-close" @click="closeModal" aria-label="Close modal">
                            x
                        </button>
                    </slot>
                </header>
                <section class="m-searchFilter-modal__body">
                    <slot name="body"></slot>
                </section>
                <footer class="m-searchFilter-modal__footer">
                    <slot name="footer">
                        <button
                            type="button"
                            @click="closeModal"
                            aria-label="Close modal">
                            Close
                        </button>
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>
